export const getCorrectValueFromSearch = (value, type) => {
  if (type === "boolean") {
    return Boolean(value);
  }
  return value;
};
